import Container from "components/general/Container";
import ScrollContainer from "components/general/ScrollContainer";
import { Box } from "components/ui";
import { usePathname } from "expo-router";
import React from "react";
import { ActivityIndicator, Platform } from "react-native";
import ItemDetail from "screens/ItemDetail";
import PageDetail from "screens/PageDetail";
import { useGetPageQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import PageDetailArticle from "./PageDetailArticle";
import PageNotFound from "./PageNotFound";

export default function GenericPageHandling() {
	const pathname = usePathname();
	const pathParts = pathname.split("/");

	const skipPaths = ["", "products", "equipment", "admin", "search", "cart", "checkout", "reports", "profile", "account", "login", "register", "forgot-password", "reset-password", "order", "/", "finance"];

	let skip = skipPaths.includes(pathParts[1]) || pathParts.length < 2;

	if (pathParts[1] === "articles" && pathParts.length < 3) {
		skip = true;
	}
	const { data: page, isLoading: pageIsLoading } = useGetPageQuery({ path: pathname }, { skip });

	const isMobile = useIsMobile();

	if (pageIsLoading) {
		const loadingSpinner = <ActivityIndicator size="large" color="#1A428A" style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }, { translateY: 25 }] }} />;

		return isMobile && Platform.OS !== "web" ? (
			<Box minHeight={300} marginTop={50}>
				{loadingSpinner}
			</Box>
		) : (
			<ScrollContainer>
				<Container sx={{ minHeight: 300, alignItems: "center", justifyContent: "center", paddingBottom: 100 }}>{loadingSpinner}</Container>
			</ScrollContainer>
		);
	}
	// Render everything conditionally inside one return
	return <>{page?.item ? <ItemDetail item={page.item} /> : page?.path?.startsWith("/articles/") ? <PageDetailArticle page={page} /> : page ? <PageDetail page={page} /> : <PageNotFound />}</>;
}
